module.exports = __webpack_public_path__ + "assets/img/0.beecccb8.png";